import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';

interface CCAvenueProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const CCAvenueProcessorDetailsPage = ({ processor }: CCAvenueProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="ccavenue" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
    </>
  );
};
